import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import { userServiceLayoutConnect } from 'modules/Common/reducers/userService';
import { load, isLoading, get } from 'modules/HorseRacing/reducers/mostfollowed';

import { Link } from 'react-router';
import config from 'config';

import {localFullDateShort} from 'utils/LocalDateTimeHelper';
import SubscriptionContainer from 'modules/Common/containers/Subscriptions/SubscriptionContainer';
import MyStableButton from 'modules/Common/containers/Subscriptions/MyStableButton';
import Silk from 'modules/Common/components/Silk';
import SwitchBtns from 'modules/Common/components/SwitchBtns';

require('./HorseRacingMostFollowed.scss');

@standardAsyncConnect([{
    dispatch: () => load("horse"),
    preventResolve: ({state}) => isLoading(state),
    refreshInterval: 600000, // 10 minutes
    state: get
  },
  userServiceLayoutConnect()
])
export default class HorseRacingMostFollowed extends Component {
  static propTypes = {
    mostFollowed: PropTypes.array,
    dispatch: PropTypes.func
  }

  constructor(...args) {
    super(...args);

    this.state = {
      list: "horse"
    }
  }

  showList(list) {
    this.props.dispatch(load(list)).then(() => this.setState({list}));
  }

  render() {
    const {
      mostFollowed = []
    } = this.props;
    const {list} = this.state;

    return (
      <div className="most-followed">
        <div className="section-title">Most Followed</div>
        <div className="most-followed-list">
          <SwitchBtns buttons={[
              {text: "Horses",   value: "horse"},
              {text: "Jockeys",  value: "jockey"},
              {text: "Trainers", value: "trainer"}
            ]}
            onChange={(e, {value}) => this.showList(value)}
            value={this.state.list}
          />
          {mostFollowed.map(item => types[list](item))}
          {!mostFollowed.length && <p className="most-followed-nothing">There&#39;s currently nothing to show here.</p>}
        </div>
      </div>
    );
  }
}

const profile = (type, id) => `${config.canonicalBase}/racing/profiles/${type}/${id}`;

const types = {
  horse: data => horseEntry(data),
  jockey: data => personEntry("jockey", data),
  trainer: data => personEntry("trainer", data)
};

function horseEntry({
  horse: {
    name: horseName,
    horse_reference: {
      id: horseId
    } = {}
  } = {},
  trainer: {
    name: trainerName
  } = {},
  silk_filename,
  formwatch
}) {
  return <div key={horseId} className="most-followed-list-item">
    <div className="most-followed-horse-silk">
      <Link to={profile("horse", horseId)}><Silk filename={silk_filename}/></Link>
    </div>
    <div className="most-followed-horse-details">
      <p><Link to={profile("horse", horseId)}>{horseName}</Link></p>
      <p><span className="label">F:</span> {formwatch || "-"}</p>
      <p><span className="label">T:</span> {trainerName || "-"}</p>
    </div>
    <div className="most-followed-follow">
      <SubscriptionContainer
        addSubscriptions={ [{ type: "HORSE", id: horseId, text: horseName }] }
        icon={ <MyStableButton/> }
      />
    </div>
  </div>;
}
horseEntry.propTypes = {
  horse: PropTypes.object,
  trainer: PropTypes.object,
  silk_filename: PropTypes.string,
  formwatch: PropTypes.string
};

function personEntry(type, {
  person_details: {
    name: personName,
    person_reference: {
      id: personId
    } = {}
  } = {},
  run_future_entries: [{
      horse_summary: {
        name: nextHorseName
      } = {},
      horse_entry: {
        date: nextDate
      } = {}
    } = {}] = [],
  run_previous_results: [{
      horse_summary: {
        name: lastHorseName
      } = {},
      horse_entry: {
        position: lastPosition,
        runner_count: lastRunners
      } = {}
    } = {}] = []
}) {
  return <div key={personId} className="most-followed-list-item">
    <div className="most-followed-person-details">
      <p><Link to={profile(type, personId)}>{personName}</Link></p>
      <p><span className="label">Next:</span> {nextHorseName || "-"} <span className="label">Date:</span> {nextDate ? localFullDateShort(nextDate) : "-"}</p>
      <p><span className="label">Previous:</span> {lastHorseName || "-"} <span className="label">Pos:</span> {lastPosition || "-"}{!!lastRunners && `/${lastRunners}`}</p>
    </div>
    <div className="most-followed-follow">
      <SubscriptionContainer
        addSubscriptions={ [{ type: type.toUpperCase(), id: personId, text: personName }] }
        icon={ <MyStableButton/> }
      />
    </div>
  </div>
}
personEntry.propTypes = {
  person_details: PropTypes.object,
  run_future_entries: PropTypes.object,
  run_previous_results: PropTypes.object
};



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingMostFollowed.js